import { render, staticRenderFns } from "./memberEditComponent.vue?vue&type=template&id=51f06594&"
import script from "./memberEditComponent.vue?vue&type=script&lang=ts&"
export * from "./memberEditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports